import styled from "styled-components"

export const SFormHeader = styled.h2`
  font-weight: bold;
  margin-bottom: 10px;
`
